/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomerUpdateRequestState =
  typeof CustomerUpdateRequestState[keyof typeof CustomerUpdateRequestState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerUpdateRequestState = {
  REQUESTED: 'REQUESTED',
  CONFIRMED: 'CONFIRMED',
  COMPLETED: 'COMPLETED',
  COMPLETED_SENT: 'COMPLETED_SENT',
  FAILED: 'FAILED',
  FAILED_SENT: 'FAILED_SENT',
} as const;
